.bgLayer {
  position: fixed;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  overflow: hidden;
  background: var(--token-bg-dark);
}

.bgImg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  user-select: none;
  opacity: 0;
  transition: opacity var(--token-motion-bg-crossfade-ms) ease-in-out;
}

.bgImg[data-active='true'] {
  opacity: 1;
}
